import { createFileRoute } from '@tanstack/react-router';
import { ProposalFormPage } from './new';

export const Route = createFileRoute('/_dashboard/dashboard/proposals/$id/edit')({
  component: EditProposalPage,
});

function EditProposalPage() {
  const { id } = Route.useParams();
  return <ProposalFormPage editId={id} />;
}
